import React, { Component, useState,useEffect  } from 'react';
import classNames  from "classnames";
import SMAVoting from "./SMAVoting";
import Articles from "./Articles";


class IGBlock extends Component {
    constructor(props){
        super(props);
        this.state = {
            page: 2,
            alldata:[],
            havenext:true,
        }
        this.getPosts = this.getPosts.bind(this);
        this.isScrolledIntoView = this.isScrolledIntoView.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

    }


    componentDidMount(){
        this.getPosts();
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount(){
        window.removeEventListener('scroll', this.handleScroll);
    }

    isScrolledIntoView(elm,scrolltop){
        if(typeof elm == 'undefined') return;
        let docViewTop = scrolltop;
        let docViewBottom = docViewTop + ( window.outerHeight==0 ? window.innerHeight : window.outerHeight );

        let elemTop = elm.getBoundingClientRect().top+docViewTop;
        let elemBottom = elemTop + elm.getBoundingClientRect().height;

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    handleScroll(evnt){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if(this.isScrolledIntoView(document.querySelectorAll('.btn-loadmore')[0],scrollTop) && !document.querySelector('.btn-loadmore').classList.contains('load')){
            if(document.querySelector('.btn-loadmore')){
                document.querySelector('.btn-loadmore').className = document.querySelector('.btn-loadmore').className+' load';
            }
            this.getPosts();
        }
    }

    getPosts(){

        let that = this;
        var myHeaders = new Headers();
        console.log(that.state.page);
        myHeaders.append('pragma', 'no-cache');
        myHeaders.append('cache-control', 'no-cache');
        fetch('/wp-json/she-rest-api/getIGPosts/'+that.state.page,{
            method:"POST",
            headers: myHeaders
        }).then(function(res){
            return res.json();
        })
            .then(function(response){
                var newlist = that.state.alldata;
                response.forEach(element => newlist.push(element));
                console.log(newlist);
                if (response.length > 0){
                    var havenext = response[0].havenext
                    var newpage = that.state.page+1
                }else{
                    var havenext = false
                    var newpage = that.state.page+1
                }

                that.setState({alldata: newlist,havenext: havenext,page:newpage});
                document.querySelector('.btn-loadmore').classList.remove('load')
                return response;
            }).catch(function(error){
            console.error(error);
        });
    }








    render(){
        const { page, alldata,havenext} = this.state;
        const { channel } = this.props;
        let that = this;

        if (alldata.length === 0) {
            return (
                <div >
                </div>
            );
        }
        return <div>
            <div className="igposts">
                {
                    alldata.map(function(item, index) {
                        return <a href={item.link+"?utm_source="+channel+"&utm_medium=referral_web&utm_campaign=listing"}>
                            <img src={item.img} alt={item.title}/>
                        </a>
                    })
                }
                {
                    havenext?<div className="btn btn-loadmore text-center Abel">
                        <div className="btn-loadmore-over"></div>
                        <div className="btn-loading">
                            <span className="modal-pulsate" id="modal-bit-loader"></span>
                        </div>
                        <span>load more<i className="icon-arr_down-01"></i></span>
                    </div>:''
                }
            </div>
        </div>
    }

}

export default IGBlock



// WEBPACK FOOTER //
// ./src/IGBlock.js